import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { SubdomainService } from './core/services/subdomain.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: () => {
      const subdomainService = inject(SubdomainService);
      return subdomainService.hasSubdomain() ? 'teacher/landing' : 'website/home';
    },
    pathMatch: 'full',
  },
  {
    path: 'home',
    redirectTo: () => {
      const subdomainService = inject(SubdomainService);
      return subdomainService.hasSubdomain() ? 'teacher/landing' : 'website/home';
    },
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./core/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'website',
    loadChildren: () =>
      import('./features/website/website.routes').then((m) => m.websiteRoutes),
  },
  {
    path: 'student',
    loadChildren: () =>
      import('./features/student/student.routes').then((m) => m.StudentRoutes),
  },
  {
    path: 'parent',
    loadChildren: () =>
      import('./features/parent/parent.routes').then((m) => m.ParentRoutes),
  },
  {
    path: 'teacher',
    loadChildren: () =>
      import('./features/teacher/teacher.routes').then((m) => m.TeacherRoutes),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'payment-callback',
    loadComponent: () =>
      import('./core/auth/pages/payment-callback/payment-callback.component').then(
        (m) => m.PaymentCallbackComponent
      ),
  },
  {
    path: 'payment-success',
    loadComponent: () =>
      import('./core/auth/pages/payment-callback/payment-callback.component').then(
        (m) => m.PaymentCallbackComponent
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./features/website/website.routes').then((m) => m.websiteRoutes),
  },
];
